/* eslint-disable no-unused-vars */
import Vue from "vue";
import axios from "axios";
import moment from "moment";

let state = {
  orders: [],
  order: {
    loading: false
  },
  filters: {
    query: null,
    manufacturer_id: null,
    client_id: null,
    has_invalid_refs: null,
    status: []
  },
  loading: false,
  submitLoading: false,
  pagination: {
    currentPage: 1,
    perPage: 15,
    total: 0,
    from: 1,
    to: 15,
    lastPage: 1
  },
  sorting: {
    sortBy: "order_date",
    desc: true
  },
  lastSaveDate: moment(),
  savingRow: false,
  rows: [],
  rowsLoaded: false
};

const mutations = {
  setPagination(state, pagination) {
    state.pagination.currentPage = pagination.current_page;
    state.pagination.from = pagination.from;
    state.pagination.to = pagination.to;
    state.pagination.lastPage = pagination.last_page;
    state.pagination.perPage = pagination.per_page;
    state.pagination.total = pagination.total;
  },
  setOrder(state, order) {
    state.order = { ...state.order, ...order };
  },
  setOrders(state, orders) {
    state.orders = [...orders];
  },
  setSorting(state, sorting) {
    state.sorting.sortBy = sorting.sortBy;
    state.sorting.desc = sorting.desc;
  },
  setFilters(state, filters) {
    state.filters = filters;
  },
  setOrderLoading(state, loading) {
    state.order.loading = loading;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setRowsLoaded(state, loaded) {
    state.rowsLoaded = loaded;
  },
  setCurrentPage(state, page) {
    state.pagination.currentPage = page;
  },
  lastSaveDate(state, lastSaveDate) {
    state.lastSaveDate = lastSaveDate;
  },
  savingRow(state, savingRow) {
    state.savingRow = savingRow;
  },
  setRows(state, rows) {
    state.rows = [...rows];
  }
};

const actions = {
  deleteOrder({ state, commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/orders/${orderId}`)
        .then(resp => {
          resolve(true);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getOrders({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);
      axios
        .get(`/api/orders`, {
          params: {
            ...state.filters,
            ...state.sorting,
            page: state.pagination.currentPage
          }
        })
        .then(resp => {
          commit("setPagination", resp.data.meta);
          commit("setOrders", resp.data.data);
          resolve(resp.data.data);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  },
  getRows({ state, commit }, orderId) {
    return new Promise((resolve, reject) => {
      commit("setRowsLoaded", false);
      axios
        .get(`/api/orders/${orderId}/rows?noPagination`)
        .catch(error => {
          reject(error);
        })
        .then(resp => {
          commit("setRows", resp.data.data);
          resolve(resp.data.data);
        })
        .finally(() => {
          commit("setRowsLoaded", true);
        });
    });
  },
  getOrder({ state, commit }, orderId) {
    return new Promise((resolve, reject) => {
      commit("setLoading", true);
      axios
        .get(`/api/orders/${orderId}`)
        .catch(error => {
          reject(error);
        })
        .then(resp => {
          commit("setOrder", resp.data.data);
          resolve(resp.data.data);
        })
        .finally(() => {
          commit("setLoading", false);
        });
    });
  },
  updatePagination({ state, commit }, page) {
    commit("setCurrentPage", page);
  },
  updateSorting({ state, commit }, sorting) {
    commit("setSorting", sorting);
  },
  updateFilters({ state, commit }, filters) {
    commit("setFilters", filters);
  },
  updateLastSaveDate({ state, commit }, lastSaveDate) {
    commit("lastSaveDate", lastSaveDate);
  }
};

const getters = {
  userById: (state, getters, rootState) => id => {
    if (state.user.id == id) {
      return state.user;
    } else if (rootState.authentication.user.id == id) {
      return rootState.authentication.user;
    }
    return state.users.find(user => user.id == id);
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
